const convertLocale = (list) =>
  list.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {});

export default convertLocale;
